module.exports = __webpack_public_path__ + "img/error-page-bg-light.ef221061.png";